import { getTotalCountryListApi, getAreaListApi, throughCountryGetExpressApi } from '@/apis/user'
import { isD2C } from '@/store'
let country: any = []
getTotalCountryListApi({
  level: 2
}).then((res: any) => {
  country = res.data || []
})
// 获取所有国家
export const getTotalCountryList: any = () => {
  return new Promise((resolve) => {
    if (country.length === 0) {
      getTotalCountryListApi({
        level: 2
      }).then((res: any) => {
        country = res.data || []
        resolve(country)
      })
    } else {
      resolve(country)
    }
  })
}

// 获取国家对应的城市
const area: any = {}
export const getAreaList: any = (item: {intAreaId :string}) => {
  return new Promise((resolve) => {
    console.log('getAreaList', area, item)
    if (!item.intAreaId) return []
    if (!area[item.intAreaId] || area[item.intAreaId].length === 0) {
      getAreaListApi({
        intAreaId: item.intAreaId
      }).then((res: any) => {
        area[item.intAreaId] = res?.data?.children || []
        resolve(res?.data?.children || [])
      })
    } else {
      resolve(area[item.intAreaId])
    }
  })
}

export interface GEL {
  countryCode: string
  countryJpyName: string
  systemSource: number
}
export const getExpressList = ({ countryCode, countryJpyName, systemSource }: GEL) => {
  return throughCountryGetExpressApi({
    countryCode,
    countryJpyName,
    systemSource
  })
}

// 根据code回显国家省市区
export interface GACN {
  area?: string // id市
  city?: string // id区
  countryCode?: string // JP
}
export const getAddressCodeName = async (data: GACN) => {
  console.log('data', data)
  // 所有国家
  const addressInfo:any = {
    ...data,
    countryList: [], // 国家列表
    countryItem: {}, // 国家名称
    areaList: [], // 省
    areaItem: {
      children: []
    }, // 省名
    cityList: [], // 城市
    cityItem: {} // 城市名称
  }
  addressInfo.countryList = await getTotalCountryList()
  addressInfo.countryItem = addressInfo.countryList.find((i: any) => i.code === data.countryCode) || {}
  if (!data.countryCode) return addressInfo
  addressInfo.areaList = await getAreaList(addressInfo.countryItem)
  if (data.area) {
    addressInfo.areaItem = addressInfo.areaList.find((i: any) => i.intAreaId === data.area) || {
      children: []
    }
    addressInfo.cityList = addressInfo.areaItem?.children
    if (data.city && data.city !== '-') {
      addressInfo.cityItem = addressInfo.areaItem?.children.find((i: any) => i.intAreaId === data.city) || {}
    }
  }
  console.log('addressInfo', addressInfo)
  return addressInfo
}

// 根据cn转换+81
export const changeCountryCodeToPhoneCode = (code:string) => {
  if (!code) return
  const countryItem = country.find((i:any) => i.code === code)
  console.log('countryItem', countryItem)
  return countryItem?.areaNum ? '+' + countryItem?.areaNum : ''
}
